import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  input: {
    fontSize: theme.typography.body2.fontSize,

    '& input': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },

    '& p': {
      fontSize: theme.typography.body2.fontSize,
    },
  },
  monetaryInput: {
    paddingLeft: theme.spacing(1),

    '& input': {
      paddingRight: theme.spacing(1),
    },
  },
  percentageInput: {
    paddingRight: theme.spacing(1),

    '& input': {
      paddingLeft: theme.spacing(1),
    },
  },
}));

export default useStyles;
